export enum CompanyType {
  Employer = 'Employer',
  Hospice = 'Hospice',
  LongtermCare = 'Long-term Care',
  DeathCare = 'Death Care',
  HealthSystem = 'Health System',
  HealthPlan = 'Health Plan',
}
